import Vue from 'vue';

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

Vue.directive('click-outside-v2', {
  bind: function (el, binding, vnode) {
    el.classList.add('js-click-outside');
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        if (!event.target.closest('.js-click-outside')) {
          vnode.context[binding.expression](event);
        }
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});
